/**
 * google-config.ts — PUBLIC Google client credentials for Drive import.
 *
 * The Client ID and API key are PUBLIC values, locked down in Google Cloud:
 *   - Client ID → restricted by Authorized JavaScript origins (app.editlock.io, localhost:5173).
 *   - API key   → restricted by HTTP referrer + limited to the Google Picker API.
 * They are safe to ship in the client bundle. NEVER put the OAuth client SECRET
 * here — the browser Picker/token flow does not use it.
 *
 * `.env*` is gitignored, so the committed fallbacks below make the production
 * Pages build work with no dashboard step. A deployment can still override via
 * VITE_GOOGLE_CLIENT_ID / VITE_GOOGLE_API_KEY without a code change.
 */

export const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  "791356079442-kkrp997gr9or3q4rboj85vvjg3jmhn5k.apps.googleusercontent.com";

export const GOOGLE_API_KEY =
  import.meta.env.VITE_GOOGLE_API_KEY ||
  "AIzaSyCGFLOmiD6P1FoKwt1rzOFFx19cAQH3Aw8";

/**
 * Google Cloud project NUMBER (not the ID). Passed to the Picker as appId so the
 * `drive.file` grant is correctly scoped to files the user picks. Public value.
 */
export const GOOGLE_APP_ID =
  import.meta.env.VITE_GOOGLE_APP_ID || "791356079442";

/**
 * drive.file = the app only ever sees files the user explicitly picks in the
 * Picker. Non-sensitive scope → no Google security assessment. Do NOT widen to
 * drive.readonly (that pulls in the restricted-scope review).
 */
export const GOOGLE_DRIVE_SCOPE = "https://www.googleapis.com/auth/drive.file";
